import { render, staticRenderFns } from "./AdminAccountDetails.vue?vue&type=template&id=519a6889&scoped=true"
import script from "./AdminAccountDetails.vue?vue&type=script&lang=js"
export * from "./AdminAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminAccountDetails.vue?vue&type=style&index=0&id=519a6889&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a6889",
  null
  
)

export default component.exports